/**
 * Theme model (design-language §9). Two themes (day / night), chosen per *surface*:
 *   Live  → night (kiosk, cinematic)   Admin → day (laptop, legible)   Staff → day (floor)
 * Each surface is individually flippable; the choice persists per surface in localStorage.
 * A [data-brand] override layer (branding/<overlay>) can later restyle either theme.
 */

export type Theme = 'day' | 'night';
export type Surface = 'live' | 'admin' | 'staff';

export const SURFACE_DEFAULT: Record<Surface, Theme> = {
  live: 'night',
  admin: 'day',
  staff: 'day',
};

const key = (s: Surface) => `gg.theme.${s}`;

export function readTheme(surface: Surface): Theme {
  try {
    const v = localStorage.getItem(key(surface));
    if (v === 'day' || v === 'night') return v;
  } catch {
    /* private mode / disabled storage → fall back to the sensible default */
  }
  return SURFACE_DEFAULT[surface];
}

export function writeTheme(surface: Surface, theme: Theme): void {
  try {
    localStorage.setItem(key(surface), theme);
  } catch {
    /* non-fatal */
  }
}
